'use strict';

import register from './core';
import '../functions/jquery-global.js';
import { trackLink } from '../functions/common';

register('student-toolbox', function (element) {
  let $el = $(element),
    $flap = $el.find('.toolbox-flap'),
    $flap_btn = $el.find('.toolbox-flap button'),
    $close_btn = $el.find('.toolbox-close'),
    $menu = $el.find('.toolbox-menu'),
    $bar = $el.find('.toolbox-bar'),
    $document = $(document),
    $link = $el.find('a.floatmenu-item-link'),
    $window = $(window),
    closeMenu = function () {
      $flap.addClass('open');
      $flap_btn.removeAttr('aria-expanded');
      $close_btn.removeAttr('aria-expanded');
      $document.off('click.student-toolbox');
      $menu.removeClass('open');
    };

  $link.on('click', function (e) {
    var label = $(this).attr('title');
    trackLink('sz', 'CTA', 'Click', label);
  });

  $flap.on('click', function (e) {
    e.stopPropagation();
    $flap.removeClass('open');
    $flap_btn.attr('aria-expanded', true);
    $close_btn.attr('aria-expanded', true);
    $menu.addClass('open');
    $document.on('click.student-toolbox', function (e) {
      // Close the menu if we clicked outside it
      if ($menu.has(e.target).length === 0) {
        closeMenu();
      }
    });
  });

  $menu.on('click', '.toolbox-close', function (e) {
    e.stopPropagation();
    closeMenu();
  });

  // Add scroll event only on mobile
  if ($document.width() > 576) {
    return;
  }

  // TODO: Better naming below

  let lastPos = $document.scrollTop(),
    lastSwitchedDirPos = lastPos,
    lastScrolledDown = true,
    scrollDiff = 0,
    threshold = 150; // How many pixels to scroll before hiding/showing the bar

  $window.on('scroll', function () {
    let pos = $document.scrollTop(),
      scrollingDown = pos > lastPos,
      expanded = $bar.hasClass('open');

    if (scrollingDown !== lastScrolledDown) {
      lastSwitchedDirPos = $document.scrollTop();
      scrollDiff = 0;
    }

    scrollDiff = Math.abs(lastSwitchedDirPos - pos);

    if (scrollDiff > threshold) {
      if (scrollingDown && expanded === true) {
        $bar.removeClass('open');
      }
      else if (!scrollingDown && expanded === false) {
        $bar.addClass('open');
      }
    }

    lastPos = pos;
    lastScrolledDown = scrollingDown;
  });

});
